import Ajax from '../utils/Ajax';
import AppDispatcher from '../dispatcher/AppDispatcher';
import BankTransferConstants from '../constants/BankTransferConstants';

const HTTP_CONFLICT = 409;

export default {
    resetBankTransferState: function (bookingIds) {
        AppDispatcher.handleAction({
            actionType: BankTransferConstants.BANK_TRANSFER_RESET,
            data: {
                booking_ids: bookingIds,
            },
        });
    },

    // payload: { id (payment id), booking_id, files } for single-mode,
    // or { ids (payment ids), booking_ids, files } for multi-mode -- one combined request covering all booking_ids
    createBankTransferRequest: function (payload) {
        const bookingIds = Array.isArray(payload.booking_ids) ? payload.booking_ids : [payload.booking_id];

        AppDispatcher.handleAction({
            actionType: BankTransferConstants.BANK_TRANSFER_LOADING,
            data: {
                booking_ids: bookingIds,
            },
        });

        Ajax.createBankTransferRequest(payload, (progress) => {
            AppDispatcher.handleAction({
                actionType: BankTransferConstants.BANK_TRANSFER_PROGRESS,
                data: {
                    booking_ids: bookingIds,
                    progress,
                },
            });
        })
            .done((request) => {
                console.log('Got bank transfer request:', request);
                const { reference_number } = request || {};
                if (!reference_number) {
                    console.error('Reference number not found on response');
                    AppDispatcher.handleAction({
                        actionType: BankTransferConstants.BANK_TRANSFER_FAILED,
                        data: {
                            booking_ids: bookingIds,
                        },
                    });
                    return;
                }

                AppDispatcher.handleAction({
                    actionType: BankTransferConstants.BANK_TRANSFER_SUCCESS,
                    data: {
                        booking_ids: bookingIds,
                        request,
                    },
                });
            })
            .fail((err) => {
                console.error('Error while creating bank transfer request:', err);
                const conflict = err?.status === HTTP_CONFLICT ? err?.responseJSON || {} : {};
                AppDispatcher.handleAction({
                    actionType: BankTransferConstants.BANK_TRANSFER_FAILED,
                    data: {
                        booking_ids: bookingIds,
                        error_code: conflict.error_code || null,
                        // The refused booking, so a multi-booking submit can name it. Absent from older servers.
                        error_short_id: conflict.short_id || null,
                    },
                });
            });
    },
};
